import React from "react";
import "./TelegramComponent.css";
import { FaTelegram } from "react-icons/fa";

const TelegramComponent = () => {
    return (
        <div className="telegram-container">
            <FaTelegram className="telegram-icon" />
            <div className="telegram-text">
                <h5 className="telegram-title">Favorite Crypto Exchanger</h5>
                <p className="telegram-description">
                    Официальный телеграм канал обменного пункта
                </p>
		<a href="https://t.me/favoritecrypto_exchange">
                <button className="telegram-button">Перейти</button>
		</a>
            </div>
            <FaTelegram className="telegram-icon-2" />
        </div>
    );
};

export default TelegramComponent;
